import React, { useState } from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  reset as authorizedReset, setSelectedContentType,
} from '../actions'; // eslint-disable-line import/no-useless-path-segments
import {
  reset as unauthorizedReset,
  logOut,
} from '../../unauthorizedState/actions';

import {
  setState,
} from '../../actions';
import {
  STATE__ANONYMOUS,
  STATE__AUTHORIZED,
  STATE__UNAUTHORIZED,
} from '../../constants';

import {
  deleteAuthorizationJwtTokenFromLocalStorage,
  deleteAuthorizationRefreshTokenFromLocalStorage,
} from '../../helpers/localStorageHelper';

import SettingsButtonBlueImage from '../../assets/icons/settings-blue.svg';
import SettingsButtonNavyImage from '../../assets/icons/settings-navy.svg';
import SignOutButtonBlueImage from '../../assets/icons/sign-out-blue.svg';
import SignOutButtonNavyImage from '../../assets/icons/sign-out-navy.svg';
import { AUTHORIZED_CONTENT_TYPE_USER_SETTINGS } from '../constants';
import useGetCurrentUserSettings from '../../shared/hooks/useGetCurrentUserSettingsHook';

import Timer from './timer';

const Actions = () => {
  const dispatch = useDispatch();

  const state = useSelector((store) => store.application.get('state'));

  const { userSettings } = state === STATE__AUTHORIZED ? useGetCurrentUserSettings(null) : { userSettings: null };

  const settingsButtonClick = () => {
    dispatch(setSelectedContentType(AUTHORIZED_CONTENT_TYPE_USER_SETTINGS));
  };

  const signOutSuccess = (deleteToken) => {
    dispatch(authorizedReset());
    dispatch(unauthorizedReset());

    dispatch(setState(STATE__UNAUTHORIZED));

    if (deleteToken) {
      deleteAuthorizationJwtTokenFromLocalStorage();
      deleteAuthorizationRefreshTokenFromLocalStorage();
    }
  };

  const signOutButtonClick = () => {
    if (state === STATE__ANONYMOUS) {
      signOutSuccess();
    } else {
      dispatch(logOut(() => signOutSuccess(true)));
    }
  };

  const [isSettingsButtonHover, setIsSettingsButtonHover] = useState(false);
  const [isSignOutButtonHover, setIsSignOutButtonHover] = useState(false);

  let userName = '';
  if (userSettings && userSettings.firstName) {
    userName = userSettings.firstName;
  }
  if (userSettings && userSettings.lastName) {
    userName += ` ${userSettings.lastName}`;
  }
  if (userSettings && userSettings.organizationName) {
    userName += ` - ${userSettings.organizationName}`;
  }
  const isAuthorized = state === STATE__AUTHORIZED;
  const signOutButtonCaption = isAuthorized ? 'Wyloguj' : 'Powrót na stronę logowania';

  return (
    <div className="actions col">
      <div className="user-section">
        <If condition={isAuthorized}>
          <div className="user-fullname">
            <span>{userName}</span>
          </div>
          <div
            className="settings-button"
            onMouseEnter={() => setIsSettingsButtonHover(true)}
            onMouseLeave={() => setIsSettingsButtonHover(false)}
            onClick={settingsButtonClick}
            role="button"
            title="Ustawienia"
          >
            <Choose>
              <When condition={isSettingsButtonHover}>
                <img src={SettingsButtonBlueImage} alt="Ustawienia" />
              </When>
              <Otherwise>
                <img src={SettingsButtonNavyImage} alt="Ustawienia" />
              </Otherwise>
            </Choose>
          </div>
        </If>
        <div
          className="sign-out-button"
          onMouseEnter={() => setIsSignOutButtonHover(true)}
          onMouseLeave={() => setIsSignOutButtonHover(false)}
          onClick={signOutButtonClick}
          role="button"
          title={signOutButtonCaption}
        >
          <div className="sign-out-timer">
            <span className="sign-out-timer-text">{signOutButtonCaption}</span>
            <span className="sign-out-timer-time"><Timer logout={() => signOutSuccess(true)} /></span>
          </div>
          <Choose>
            <When condition={isSignOutButtonHover}>
              <img src={SignOutButtonBlueImage} alt={signOutButtonCaption} />
            </When>
            <Otherwise>
              <img src={SignOutButtonNavyImage} alt={signOutButtonCaption} />
            </Otherwise>
          </Choose>
        </div>
      </div>
    </div>
  );
};

export default Actions;
